module.exports = __webpack_public_path__ + "static/media/mk.b90716af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/mk.svg
// module id = 1460
// module chunks = 0